import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './components/app';
import store, { persistor } from './store/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
Sentry.init({
    dsn: "https://001fe43adc0e4c8699f9acb2b442d7f6@o68785.ingest.sentry.io/5632136",
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});
// Persist gate stops page from loading until the state is rehydrated
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(PersistGate, { loading: null, persistor: persistor },
        React.createElement(App, null))), document.getElementById("app"));
